import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from "@angular/core";
import {CommonModule} from "@angular/common";
import {LanguageUtilComponent} from "./components/language.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {FilterPipe} from "./service/filterPipe";
import {OrderBy} from "./service/orderBy.service";
import {UploadPassport} from "./components/upload-passport/upload-passport";
import {FileUploadModule} from "ng2-file-upload";
import {Safe} from "./service/keep-html.pipe";
import { FooterComponent } from './layouts';
import { TransformMoneyPipe } from "./pipe/transformMoney.pipe";
import { TransformCustomDatePipe } from "./pipe/transformCustomDate.pipe";
import { PagingComponent } from "./components/paging/paging";
import { TransformPhonePipe } from "./pipe/transformPhone.pipe";
import { ConfirmDialogComponent } from "../main/dialog/confirm-dialog";
import { DetailAgent } from "../main/components/detail-agent/detail-agent";
import { DocumentsComponent } from "./components/documents/documents";
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DropdownSearchComponent } from './components/dropdown-search/dropdown-search.component';
import { PublicViewImageComponent } from "./components/public-view-image/public-view-image";
import { NewPagingComponent } from "./components/new-paging/new-paging.component";
import { UploadingIcon } from "./components/uploading-icon/uploading-icon.component";
import { UserAuthorityDirective } from "../main/services/user-authority.directive";
import { ErrorTextComponent } from "./components/error-text/error-text.component";
import { NewOTPComponent } from "./components/otp/otp.component";
import { ChangePassword } from 'src/app/main/components/change-password/change-password';
import { ChangeMail } from 'src/app/main/components/change-mail/change-mail';
import { ChangePhone } from 'src/app/main/components/change-phone/change-phone';
import { DetailIssuer } from "./components/detail-issuer/detail-issuer";
import { DetailNewFund } from "./components/detail-new-fund/detail-new-fund";
import { DetailTradingFund } from "./components/detail-trading-fund/detail-trading-fund";
import { DetailFee } from "./components/detail-fee/detail-fee";
import { FeatureMaintenanceComponent } from "./components/feature-maintenance/feature-maintenance.component";
import { FilterStartEndDateComponent } from "./components/filter-start-end-date/filter-start-end-date";
import { SearchFilterComponent } from "./components/search-filter/search-filter.component";
import { ClipboardModule } from 'ngx-clipboard';
import { ButtonCopyComponent } from "./components/button-copy/button-copy.component";
import { IsMainFODirective } from "../main/services/is-main-fo.directive";
import { UserTypeDirective } from "../main/services/user-type.directive";
import { InputNumberComponent } from "./components/input-number/input-number";
import { InputDateComponent } from "./components/input-date/input-date";
import { TabsModule } from "ngx-bootstrap/tabs";
import { ModalModule } from "ngx-bootstrap/modal";
import { PopoverModule } from "ngx-bootstrap/popover";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NzToolTipModule   } from 'ng-zorro-antd/tooltip';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule  } from 'ng-zorro-antd/select';
import { NzTableModule  } from 'ng-zorro-antd/table';
import { NzTabsModule  } from 'ng-zorro-antd/tabs';
import { NzAvatarModule  } from 'ng-zorro-antd/avatar';
import { NzAlertModule  } from 'ng-zorro-antd/alert';
import { NzProgressModule  } from 'ng-zorro-antd/progress';
import { NzPopoverModule    } from 'ng-zorro-antd/popover';
import { NzSwitchModule   } from 'ng-zorro-antd/switch';
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    ModalModule,
    TabsModule,
    PopoverModule,
    TooltipModule,
    NgbModalModule,
    FileUploadModule,
    HttpClientModule,
    TranslateModule,
    ClipboardModule,
    NzIconModule,
    NzTagModule,
    NzBadgeModule,
    NzModalModule,
    NzCardModule,
    NzTabsModule,
    NzListModule,
    NzPageHeaderModule,
    NzFormModule,
    NzLayoutModule,
    NzDropDownModule,
    NzButtonModule,
    NzSelectModule,
    NzTableModule,
    NzAvatarModule,
    NzInputModule,
    NzAlertModule,
    NzPaginationModule,
    NzProgressModule,
    NzToolTipModule,
    NzPopoverModule,
    NzSwitchModule,
    NzDividerModule
  ],
  declarations: [
    LanguageUtilComponent,
    FilterPipe,
    OrderBy,
    UploadPassport,
    Safe,
    FooterComponent,
    ConfirmDialogComponent,
    TransformCustomDatePipe,
    TransformMoneyPipe,
    TransformPhonePipe,
    DetailIssuer, DetailAgent,
    PagingComponent,
    NewPagingComponent,
    DropdownSearchComponent, SearchFilterComponent,
    UploadingIcon,
    UserAuthorityDirective,
    IsMainFODirective,
    UserTypeDirective,
    PublicViewImageComponent,
    ErrorTextComponent,
    DocumentsComponent,
    ChangePassword,
    ChangeMail,
    ChangePhone,
    NewOTPComponent,
    DetailNewFund, DetailTradingFund, DetailFee,
    FeatureMaintenanceComponent,
    FilterStartEndDateComponent,
    ButtonCopyComponent,
    InputNumberComponent,
    InputDateComponent,
  ],
  providers: [
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule,
    FileUploadModule,
    TabsModule,
    ModalModule,
    PopoverModule,
    ClipboardModule,
    NzIconModule,
    NzTagModule,
    NzBadgeModule,
    NzModalModule,
    NzCardModule,
    NzTabsModule,
    NzListModule,
    NzPageHeaderModule,
    NzFormModule,
    NzLayoutModule,
    NzDropDownModule,
    NzButtonModule,
    NzSelectModule,
    NzTableModule,
    NzAvatarModule,
    NzInputModule,
    NzAlertModule,
    NzPaginationModule,
    NzProgressModule,
    NzToolTipModule,
    NzPopoverModule,
    NzSwitchModule,
    NzDividerModule,
    LanguageUtilComponent,
    ConfirmDialogComponent,
    FilterPipe,
    OrderBy,
    UploadPassport,
    Safe,
    FooterComponent,
    TransformCustomDatePipe,
    TransformMoneyPipe,
    DetailIssuer, DetailAgent,
    PagingComponent,
    NewPagingComponent,
    NewOTPComponent,
    DocumentsComponent,
    ChangePassword,
    ChangeMail,
    ChangePhone,
    DropdownSearchComponent, SearchFilterComponent,
    UploadingIcon,
    UserAuthorityDirective,
    UserTypeDirective,
    ErrorTextComponent,
    FilterStartEndDateComponent,
    ButtonCopyComponent,
    IsMainFODirective,
    InputNumberComponent,
    InputDateComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule{ }
